import script from "./AppSettingsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppSettingsPage.vue?vue&type=script&setup=true&lang=ts"

import "./AppSettingsPage.vue?vue&type=style&index=0&id=3601a1f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3601a1f6"]])

export default __exports__